export default __webpack_public_path__ + "static/media/logo.dae69fbe.svg";